import { useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

export default function (ComposedComponent) {
  function Admin(incomingProps) {
    const props = {
      ...{
        user: {},
      },
      ...incomingProps,
    };
    const history = useHistory();
    const { user } = props;

    useEffect(() => {
      if (!_.isEmpty(user) && !user.is_admin) {
        history.push('/dashboard');
      }
    }, [user, history]);

    /* eslint-disable react/jsx-props-no-spreading */
    return <ComposedComponent {...props} />;
  }

  Admin.propTypes = {
    user: PropTypes.object.isRequired,
  };

  function mapStateToProps(state) {
    return {
      user: state.user,
    };
  }

  return connect(mapStateToProps)(Admin);
}
